import _concat from "ramda/es/concat";
import _mergeWith from "ramda/es/mergeWith";

var mergeWithConcat = _mergeWith(_concat);

export default mergeWithConcat;